import { render } from "./ReihenhausStep9.vue?vue&type=template&id=5087599c&scoped=true"
import script from "./ReihenhausStep9.vue?vue&type=script&lang=js"
export * from "./ReihenhausStep9.vue?vue&type=script&lang=js"

import "./ReihenhausStep9.vue?vue&type=style&index=0&id=5087599c&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5087599c"]])

export default __exports__